module.exports = __webpack_public_path__ + "static/media/4.df7c7098.svg";